<p-toast />
<div class="layout-centered">
  <p-card styleClass="card-style-account">
    <ng-template pTemplate="header">
      <img src="/assets/images/logo-redcurve.png" id="logo-redcurve" />
    </ng-template>

    <h1 class="h3 mb-4">Phone Number Verification</h1>
    <form [formGroup]="verificationForm">
      <div class="field mb-2">
        <label for="phoneNumber">Phone Number</label>
        <input type="text" pInputText formControlName="phoneNumber" placeholder="Enter phone number" [disabled]="isCodeSent" />
      </div>
      <!-- Disable Send Code button if phone number is invalid -->
      <div class="text-center mt-3">
        <button pButton
          type="button"
          label="Send Code"
          (click)="sendVerificationCode()"
          [disabled]="verificationForm.controls['phoneNumber'].invalid">
        </button>
      </div>

      <div class="field mt-5 mb-2">
        <label for="verificationCode">Verification Code</label>
        <input type="text" pInputText formControlName="verificationCode" placeholder="Enter code" [disabled]="!isCodeSent" />
      </div>
      <div class="text-center mt-3">
        <button pButton
          type="button"
          label="Verify"
          (click)="verifyCode()"
          [disabled]="!isCodeSent || verificationForm.get('verificationCode')?.invalid">
        </button>
      </div>
    </form>
  </p-card>

  <div class="centered-footer">
    <span>Copyright &copy; 2025</span> |
    <span>RedCurve Solutions &reg;</span> |
    <span>All Rights Reserved</span>
  </div>
</div>
